import { Component, ElementRef, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { MatMenu, MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { Subscription, fromEvent } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { TemplateContextMenuItem } from '../Interfaces/template-context-menu-item';
import { TemplateContextMenuItemEvent } from '../Interfaces/template-context-menu-item-event';

@Component({
    selector: 'app-template-context-menu',
    templateUrl: './template-context-menu.component.html',
    styleUrls: ['./template-context-menu.component.scss'],
    imports: [MatMenuModule]
})
export class TemplateContextMenuComponent implements OnDestroy {
    /**
     * Menu contextuel
     */
    @ViewChild(MatMenu) matMenu: MatMenu;
    @ViewChild(MatMenuTrigger) contextMenu: MatMenuTrigger;
    contextMenuPosition = { x: '0px', y: '0px' };
    clickOutside$: Subscription;

    /**
     * Liste des éléments à afficher dans le menu contextuel.
     */
    @Input()
    contextMenuItems: Array<TemplateContextMenuItem>;

    /**
     * Emis lorsque le menu contextuel se ferme.
     */
    @Output()
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    onClosed: EventEmitter<boolean> = new EventEmitter<boolean>();

    /**
     * Emis lorsque l'utilisateur clique sur un élément du menu contextuel.
     */
    @Output()
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    onContextMenuItemClick: EventEmitter<TemplateContextMenuItemEvent> = new EventEmitter<TemplateContextMenuItemEvent>();

    // clickOutside$: Subscription;

    private get element() {
        return this.host.nativeElement;
    }

    constructor(private host: ElementRef) {
        this.clickOutside$ = fromEvent<MouseEvent>(document, 'click')
            .pipe(
                filter((event) => {
                    const clickTarget = event.target as HTMLElement;
                    return !!this.element && !this.element.contains(clickTarget);
                }),
                take(1)
            )
            .subscribe(() => this.close());
    }

    public openMenu(event: MouseEvent) {
        this.contextMenuPosition.x = event.clientX - 5 + 'px';
        this.contextMenuPosition.y = event.clientY - 10 + 'px';
        this.contextMenu.openMenu();
    }

    public onLeaveContextMenu() {
        this.contextMenu.closeMenu();
    }

    ngOnDestroy(): void {
        console.log('ngOnDestroy');
        this.clickOutside$ && this.clickOutside$.unsubscribe();
    }

    close() {
        this.clickOutside$ && this.clickOutside$.unsubscribe();
        this.onClosed.emit(true);
    }

    /**
     * Levé lorsque l'utilisateur clique sur un élément du menu contextuel.
     * @param event
     * @param data
     */
    onContextMenuClick(event: MouseEvent, data: TemplateContextMenuItem): any {
        this.onContextMenuItemClick.emit(new TemplateContextMenuItemEvent(data.variable, data.source));
    }
}
